import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import authService from '../services/authService';

function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="navigation">
      <div className="nav-content">
        <div className="nav-logo">
          <img src="/logo-iol-outline-dark.svg" alt="Input Output Logo" />
          <span className="nav-brand">IO Forms</span>
        </div>
        
        <div className="nav-links">
          <button 
            onClick={() => navigate('/forms')} 
            className={`nav-link ${isActive('/forms') ? 'active' : ''}`}
          >
            Available Forms
          </button>
          <button 
            onClick={() => navigate('/my-submissions')} 
            className={`nav-link ${isActive('/my-submissions') ? 'active' : ''}`}
          >
            My Submissions
          </button>
        </div>

        <button onClick={handleLogout} className="btn-logout">
          Logout
        </button>
      </div>
    </nav>
  );
}

export default Navigation;
